/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
/** @packageDocumentation
 * @module Content
 */

/**
 * Describes property renderer used for a content [[Field]].
 * @public
 */
export interface RendererDescription {
  /** Renderer name. */
  name: string;
}
